<template>
    <v-flex xs12 class="white mt-5">
        <v-card class="elevation-0 pa-5" flat>
            <v-layout wrap row grid >
                <v-flex xs12 sm3>
                    <v-text-field  color="teal" v-model="telefone" clear-icon label="Telefone" placeholder="(##) ##### - ####" v-mask="'(##)#####-####'"></v-text-field>
                    <v-alert :value="alert" text-center color="success" class="headline-3" >Pedido realizado!</v-alert>
                </v-flex>
                <v-flex xs12 sm3 class="ml-2">
                    <v-btn color="fundo" large round @click="createTicket">
                        <v-icon left>
                        add
                        </v-icon>
                        Realizar Pedido
                    </v-btn>

                </v-flex>
                <v-dialog v-model="modalSemDados" max-width="380">
                    <v-card>
                        <v-card-title class="headline pa-3" color="blue-grey darken-3" ><v-icon left >speaker_notes_off</v-icon> Informe o número do celular!</v-card-title>
                        <v-card-text></v-card-text>
                    </v-card>
                </v-dialog>
            </v-layout>
        </v-card>
    </v-flex>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'


export default {

    data(){
        return {
            telefone:'',
            modalSemDados:false,
            alert:false
        }
    },

    components:{
    },
    methods: {
        ...mapActions(['createTicketQueroTaxi','loadPedidosQueroTaxi', 'loadUserLocal', 'isClientQueroTaxi']),
        async createTicket(dominio, token){
            const resultado = await this.createTicketQueroTaxi({
                dominio  : this.system.empresaQueroTaxi.dominio,
                token    : this.system.empresaQueroTaxi.token,
                telefone : this.telefone
            })
            this.telefone = ''

            if(resultado.status == false){
                this.modalSemDados = true
            }else{
                this.alert = true
            }
        }
    },

    computed:{
        ...mapState(['system']),
        ...mapGetters(['getUserLocal']),

    },

    async mounted() {
        await this.loadUserLocal()
        await this.isClientQueroTaxi(this.getUserLocal.key)

        if(this.system.empresaQueroTaxi && this.system.empresaQueroTaxi._id) {
            this.dadosPedidos = await this.loadPedidosQueroTaxi({empresa_id: this.system.empresaQueroTaxi._id})
        }
    },
    watch: {
      modalSemDados (val) {
        if (!val) return
        setTimeout(() => (this.modalSemDados = false), 4000)
      },
       alert (val) {
        if (!val) return
        setTimeout(() => (this.alert = false), 3000)
      }
    }

}
</script>



// WEBPACK FOOTER //
// src/components/user/QueroTaxi/RealizarPedido.vue